import { expVal } from '@atlassian/jira-feature-experiments';

const additionalFieldsInGroupByProjectHeaderRelayProvider = {
	get(): boolean {
		return expVal('additional_fields_in_group_by_project_header_', 'isEnabled', false);
	},
};

export default additionalFieldsInGroupByProjectHeaderRelayProvider;
